/**
 * ms-grid
 * -------
 * Helps with IE support for CSS Grid
 * IE 10/11 only supports the original Grid specification
 * https://css-tricks.com/css-grid-in-ie-css-grid-and-the-new-autoprefixer/
 */
function addMsGridClasses(el, index, columns) {
    const row = Math.floor((index) / columns)+1;
    const column = ((index) % columns)+1;

    el.classList.add(`ms-grid-column-${column}`);
    el.classList.add(`ms-grid-row-${row}`);
}

export default {
    inserted: (el, {value: {index, columns}}) => addMsGridClasses(el, index, columns),
    componentUpdated: (el, {value: {index, columns}}) => addMsGridClasses(el, index, columns),
}